import checkAllRules from './engine'
import safeLocalStorage from '../../../providers/safeLocalStorageProvider'
import {
  DIRECT_TRAFFIC_ID,
  DIRECT_TRAFFIC_SOURCE,
  NAVIGATION_TRAFFIC_SOURCE,
  TRAFFIC_INFO_KEY,
} from './constants'

export const initTrafficInfo = () => {
  const traffic = {
    url: window.location.href,
    referrer: document.referrer,
  }
  const { trafficSource: newSource, trafficId: newId } = checkAllRules(traffic)
  const sessionLength = 30

  let trafficSource = newSource
  let trafficId = newId

  const trafficInfo = safeLocalStorage.get(TRAFFIC_INFO_KEY)
  if (trafficInfo !== null) {
    const { trafficSource: oldSource, trafficId: oldId, timestamp } = trafficInfo
    const timestampValue = new Date(timestamp).getTime()
    const sessionPassed = new Date(timestampValue + sessionLength * 60000) < new Date()
    const isTrafficSourceNavigation = newSource === NAVIGATION_TRAFFIC_SOURCE
    if (isTrafficSourceNavigation) {
      if (sessionPassed) {
        trafficSource = DIRECT_TRAFFIC_SOURCE
        trafficId = DIRECT_TRAFFIC_ID
      } else {
        trafficSource = oldSource
        trafficId = oldId
      }
    }
  }
  safeLocalStorage.set(TRAFFIC_INFO_KEY, { trafficSource, trafficId, timestamp: new Date() })
}

export const getTrafficInfo = () => {
  const { trafficSource, trafficId } = safeLocalStorage.get(TRAFFIC_INFO_KEY)
  return { trafficSource, trafficId }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/services/trafficAnalyzer/index.js